import React from 'react/addons'
import ComplexTable from 'components/ComplexTable'
import Range from 'components/Range'

const filtRegex = /^filter_(\w+)$/

let getBounds = list => [
	Math.floor(Math.min.apply(null, list)),
	Math.ceil(Math.max.apply(null, list))
]

const ComplexTableApp = React.createClass({

	// mixins: [React.addons.PureRenderMixin],

	getInitialState() {
		return {
			filter_d: [16, 1600],
			filter_thick: [1, 118],
			cart: this.props.flux.getStore('cartStore').getState()
		};
	},

	propTypes: {
		data: React.PropTypes.arrayOf(React.PropTypes.shape({
			d: React.PropTypes.number.isRequired,
			mass: React.PropTypes.number.isRequired,
			thick: React.PropTypes.number.isRequired,
			name: React.PropTypes.string.isRequired,
		})).isRequired,
		customColumns: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
		customCells: React.PropTypes.object.isRequired,
		names: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
		d: React.PropTypes.arrayOf(React.PropTypes.number).isRequired,
	},

	componentWillMount() {
		let bounds = {
			d: getBounds(this.props.d),
			thick: getBounds(this.props.data.map(item => item.thick))
		}
		let filter_d = bounds.d.slice()
		let filter_thick = bounds.thick.slice()

		this.setState({bounds, filter_d, filter_thick})
		this.props.flux.getStore('cartStore').listen(this.onCartChange)
	},

	componentWillUnmount() {
		this.props.flux.getStore('cartStore').unlisten(this.onChange)
	},

	onCartChange() {
		this.setState({cart: this.props.flux.getStore('cartStore').getState()})
	},

	handleFilterChange(name, value) {
		this.setState({
			['filter_' + name]: value
		})
	},

	filterData(data, state) {
		let filterKeys = Object.keys(state).filter(key => filtRegex.test(key)).map(key => key.replace(filtRegex, '$1'))
		return data.filter(item => filterKeys.filter(key => item[key] >= state['filter_' +  key][0] && item[key] <= state['filter_' +  key][1]).length === filterKeys.length)
	},

	renderEmpty() {
		return (
			<div className="complex-tbl__empty">
				Нет позиций с заданными параметрами. Попробуйте установить другие значения для фильтра
			</div>
		)
	},

	render() {
		let data = this.filterData(this.props.data, this.state)
		let bounds = this.state.bounds

		return (
			<div className="complex-tbl">
				<div className="complex-tbl__filt">
					<div className="complex-tbl__filt-i complex-tbl__filt-i--number">
						<label>
							Номинальный наружный
							диаметр ø, <strong>{this.state.filter_d.map(Math.round).join('—')} мм</strong>
						</label>
						<Range min={bounds.d[0]} max={bounds.d[1]} value={this.state.filter_d} onChange={this.handleFilterChange.bind(this, 'd')} />
					</div>

					<div className="complex-tbl__filt-i complex-tbl__filt-i--number">
						<label>
							Толщина стенки, <strong>{this.state.filter_thick.join('—')} мм</strong>
						</label>
						<Range min={bounds.thick[0]} max={bounds.thick[1]} value={this.state.filter_thick} onChange={this.handleFilterChange.bind(this, 'thick')} />
					</div>
				</div>

				{
					data.length > 0
					? <ComplexTable
						data={data}
						flux={this.props.flux}
						customCols={this.props.customColumns} customCells={this.props.customCells}
						cart={this.state.cart}
						productId={this.props.productId}
						onAddToCart={this.props.flux.getActions('cartActions').addItem}
						onRemoveFromCart={this.props.flux.getActions('cartActions').removeItem}
						cols={this.props.names} rows={this.props.d} />
					: this.renderEmpty()
				}
			</div>
		);
	}

});

export default ComplexTableApp


/** WEBPACK FOOTER **
 ** ./src/scripts/components/ComplexTableApp.js
 **/